<template>
  <div class="school-page">
    <v-flex class="hidden">{{ isMobile }}</v-flex>
    <v-flex xs12 class="school-page-header">
      <v-layout wrapper row>
        <v-flex xs12 md7 lg6>
          <v-flex class="school-page-info-wrapper">
            <v-flex xs12 class="row">
              <v-layout wrapper row>
                <v-flex xs8>
                  <v-flex class="school-name row" xs12>{{ singleSchool.name }}</v-flex>
                  <v-flex xs12 class="row">{{ $t(singleSchool.school_type) }}</v-flex>
                  <v-flex xs12 class="row hidden-md-and-up">
                    <v-flex class="add-to-compare">
                      <a href="#" @click.stop.prevent="addToCompare(singleSchool)">{{ $t('Add to compare') }}</a>
                    </v-flex>
                  </v-flex>
                </v-flex>
                <v-flex xs4>
                  <v-layout
                    wrap
                    row
                    class="school-page-action school-page-action-mobile hidden-md-and-up"
                  >
                    <v-flex>
                      <v-btn flat @click.prevent="showNotification = true;">
                        <v-icon class="notifications">notifications</v-icon>
                        {{ $t('Notify me') }}
                      </v-btn>
                    </v-flex>
                    <v-flex>
                      <a v-bind:href="'mailto:?subject=Fraser%20Institute%20School%20Rankings&body=' + currentPage">
                        <div class="v-btn v-btn--flat theme--light">
                          <div class="v-btn__content">
                            <i class="email" />
                            {{ $t('Email') }}
                          </div>
                        </div>
                      </a>
                    </v-flex>
                    <v-flex>
                      <v-btn flat @click="print()">
                        <i class="print"/>
                        {{ $t('Print') }}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 class="row">
              <v-layout wrapper row>
                <v-flex>
                  <div class="row-label">
                    {{ $t('Score') }}
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon class="tooltip-icon" v-on="on">help</v-icon>
                      </template>
                      <span v-html="toolTipByName($t('Score'))"></span>
                    </v-tooltip>
                  </div>
                  <v-flex
                    :class="[
                    singleSchool.score >= 0 && singleSchool.score < 4.1 ? 'score_color_1': '',
                    singleSchool.score >= 4.1 && singleSchool.score < 6 ? 'score_color_2': '',
                    singleSchool.score >= 6 && singleSchool.score < 7.6 ? 'score_color_3': '',
                    singleSchool.score >= 7.6 && singleSchool.score <= 10 ? 'score_color_4': ''
                  ]"
                  >{{ singleSchool.score !== 'n/a' ? (parseFloat(singleSchool.score) % 1 === 0 ? parseFloat(singleSchool.score).toFixed(0) : parseFloat(singleSchool.score).toFixed(1)) : 'n/a' }}
                  </v-flex>
                </v-flex>
                <v-flex v-if="singleSchool.ranking">
                  <div class="row-label">
                    {{ $t('Rank') }}
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon class="tooltip-icon" v-on="on">help</v-icon>
                      </template>
                      <span v-html="toolTipByName($t('Rank'))"></span>
                    </v-tooltip>
                  </div>
                  <div>{{ singleSchool.ranking }}/{{ totalSchools }}</div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-flex>

          <v-flex class="single-line hidden-sm-and-down" xs12></v-flex>
          <v-layout row wrap class="school-page-details">
            <v-expansion-panel v-model="panel">
              <v-expansion-panel-content key="0">
                <template v-slot:header>
                  <div @click="reloadSchoolMapAction()">School Details</div>
                </template>
                <v-card>
                  <SchoolPageMap
                    class="school-page-map-mobile"
                    v-if="schoolMapPageReady"
                    :singleSchool="singleSchool"
                    :iconUrl="iconUrl"
                    ref="schoolPageMap"
                  />
                  <v-flex class="school-page-details-content">
                    <v-flex xs12 class="row">
                      <v-layout wrapper row align-center>
                        <v-flex xs7 md6 class="label">{{$t('Phone')}}</v-flex>
                        <v-flex xs5 md6 class="field">{{ singleSchool.phone }}</v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex xs12 class="row website" v-if="singleSchool.website">
                      <v-layout wrapper row align-center>
                        <v-flex xs7 md6 class="label">{{ $t('Website') }}</v-flex>
                        <v-flex xs5 md6 class="field">
                          <a target="_blank" :href="singleSchool.website">{{ singleSchool.website }}</a>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex xs12 class="row">
                      <v-layout wrapper row align-center>
                        <v-flex xs7 md6 class="label">{{ $t('School District') }}</v-flex>
                        <v-flex xs5 md6 class="field">{{ singleSchool.district }}</v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex xs12 class="row" v-if="this.singleSchool.province !== 'qc'">
                      <v-layout wrapper row align-center>
                        <v-flex xs7 md6 class="label">
                          <span v-if="this.singleSchool.province !== 'bc'">ESL %</span>
                          <span v-if="this.singleSchool.province === 'bc'">ELL %</span>
                          <v-tooltip
                            top
                            v-if="toolTipByName('ESL %')"
                          >
                            <template v-slot:activator="{ on }">
                              <v-icon class="tooltip-icon" v-on="on">help</v-icon>
                            </template>
                            <span v-html="toolTipByName('ESL %')"></span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex xs5 md6 class="field">{{ singleSchool.esl }}</v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex xs12 class="row" v-if="this.singleSchool.province !== 'qc'">
                      <v-layout wrapper row align-center>
                        <v-flex xs7 md6 class="label">
                          {{ $t('special_needs') }}
                          <v-tooltip
                            top
                            v-if="toolTipByName($t('special_needs'))"
                          >
                            <template v-slot:activator="{ on }">
                              <v-icon class="tooltip-icon" v-on="on">help</v-icon>
                            </template>
                            <span v-html="toolTipByName($t('special_needs'))"></span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex xs5 md6 class="field">{{ singleSchool.special_needs }}</v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 class="row" v-if="this.singleSchool.province !== 'qc' && singleSchool.gr_enrolment">
                      <v-layout wrapper row align-center>
                        <v-flex xs7 md6 class="label">
                          {{ getEnrolmentName }}
                          <v-tooltip
                            top
                          >
                            <template v-slot:activator="{ on }">
                              <v-icon class="tooltip-icon" v-on="on">help</v-icon>
                            </template>
                            <span v-html="toolTipByName(getEnrolmentName)"></span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex xs5 md6 class="field">{{ singleSchool.gr_enrolment }}</v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 class="row" v-if="this.singleSchool.province === 'on' && this.singleSchool.ossl_count">
                      <v-layout wrapper row align-center>
                        <v-flex xs7 md6 class="label">
                          {{ $t('OSSLT count')  }}
                          <v-tooltip
                            top
                          >
                            <template v-slot:activator="{ on }">
                              <v-icon class="tooltip-icon" v-on="on">help</v-icon>
                            </template>
                            <span v-html="toolTipByName('OSSLT count')"></span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex xs5 md6 class="field">{{ this.singleSchool.ossl_count }}</v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex xs12 class="row" v-if="this.singleSchool.province !== 'qc'">
                      <v-layout wrapper row align-center>
                        <v-flex xs7 md6 class="label">
                          {{ getImmersionName }}
                          <v-tooltip
                            top
                            v-if="toolTipByName(getImmersionName)"
                          >
                            <template v-slot:activator="{ on }">
                              <v-icon class="tooltip-icon" v-on="on">help</v-icon>
                            </template>
                            <span v-html="toolTipByName(getImmersionName)"></span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex xs5 md6 class="field">{{ singleSchool.french_immersion }}</v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex xs12 class="row" v-if="this.singleSchool.province == 'qc'">
                      <v-layout wrapper row align-center>
                        <v-flex xs7 md6 class="label">{{$t('Number of students')}}
                          <v-tooltip
                            top
                            v-if="toolTipByName($t('Number of students'))"
                          >
                            <template v-slot:activator="{ on }">
                              <v-icon class="tooltip-icon" v-on="on">help</v-icon>
                            </template>
                            <span v-html="toolTipByName($t('Number of students'))"></span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex xs5 md6 class="field">{{ singleSchool.studentsNumber }}</v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex xs12 class="row" v-if="this.singleSchool.province == 'qc'">
                      <v-layout wrapper row align-center>
                        <v-flex xs7 md6 class="label">{{$t('Academic Delay (%)')}}
                          <v-tooltip
                            top
                            v-if="toolTipByName($t('Academic Delay (%)'))"
                          >
                            <template v-slot:activator="{ on }">
                              <v-icon class="tooltip-icon" v-on="on">help</v-icon>
                            </template>
                            <span v-html="toolTipByName($t('Academic Delay (%)'))"></span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex xs5 md6 class="field">{{ singleSchool.academicDelay }}</v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex xs12 class="row" v-if="this.singleSchool.province == 'qc'">
                      <v-layout wrapper row align-center>
                        <v-flex xs7 md6 class="label">{{$t('Special Needs (%)')}}
                          <v-tooltip
                            top
                            v-if="toolTipByName($t('Special Needs (%)'))"
                          >
                            <template v-slot:activator="{ on }">
                              <v-icon class="tooltip-icon" v-on="on">help</v-icon>
                            </template>
                            <span v-html="toolTipByName($t('Special Needs (%)'))"></span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex xs5 md6 class="field">{{ singleSchool.specialNeeds }}</v-flex>
                      </v-layout>
                    </v-flex>



                  </v-flex>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-layout>
        </v-flex>
        <v-flex xs12 md5 lg6 v-if="!isMobile">
          <v-layout row wrap>
            <v-flex xs6>
              <v-flex class="add-to-compare">
                <a href="#" @click.stop.prevent="addToCompare(singleSchool)">{{ $t('Add to compare') }}</a>
              </v-flex>
            </v-flex>
            <v-flex xs6>
              <v-layout wrap row class="school-page-action">
                <v-flex>
                  <v-btn flat @click.prevent="showNotification = true;">
                    {{ $t('Notify me') }}
                    <v-icon class="notifications">notifications</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex>
                  <a v-bind:href="'mailto:?subject=Fraser%20Institute%20School%20Rankings&body=' + currentPage">
                    <div class="v-btn v-btn--flat theme--light">
                      <div class="v-btn__content">
                        {{ $t('Email') }}
                        <i class="email" />
                      </div>
                    </div>
                  </a>
                </v-flex>
                <v-flex>
                  <v-btn flat @click="print()">
                    {{ $t('Print') }}
                    <i class="print"/>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <SchoolPageMap
            v-if="singleSchoolLoaded && singleSchool.coords"
            :singleSchool="singleSchool"
            :iconUrl="iconUrl"
          />
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 class="chart-table-wrapper">
      <v-flex xs12 class="chart-table-content">
        <v-flex xs12>
          <v-tabs grow hide-slider v-model="table_active" centered>
            <v-tab
              id="0"
              class="chart-button"
              @click.stop.prevent="showSchoolChart=true; showSchoolTable=false;"
            >
              <v-icon>insert_chart</v-icon>
              {{ $t('Chart') }}
            </v-tab>
            <v-tab
              id="1"
              class="table-button"
              @click.stop.prevent="showSchoolChart=false; showSchoolTable=true;"
            >
              <v-icon>table_chart</v-icon>
              Table
            </v-tab>
          </v-tabs>
        </v-flex>
        <v-flex xs12>
          <SchoolChart
            v-if="singleSchoolLoaded && showSchoolChart"
            :chartType="chartType"
            :schoolId="$route.params.id"
            :singleSchool="singleSchool"
            :averageLabel="true"
            :isSecondary="isSecondary"
          />

          <v-flex class="school-table"  :class="{ 'secondary-school' : isSecondary}"  v-show="showSchoolTable">
            <table class="school-table-table header">
              <thead>
              <tr>
                <th class="academic-performance" rowspan="2">Academic Performance</th>
                <th class="table-pagination hidden-md-and-up" colspan="3">
                  <v-btn
                    :class="[tablePageStart === 0 ? 'disabled' : '', 'button-left']"
                    flat
                    round
                    @click.prevent="previousPageStart()"
                  >
                    <v-icon>keyboard_arrow_left</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="tablePages != null"
                    :class="[tablePageStart > (tablePages.length - tableNumberPages - 1) ? 'disabled' : '']"
                    flat
                    round
                    @click.prevent="nextPageStart()"
                  >
                    <v-icon>keyboard_arrow_right</v-icon>
                  </v-btn>
                </th>
              </tr>
              <tr>
                <th
                  class="academic-performance-year"
                  v-for="(item, index) in tableCurrentPages"
                  :key="`year_${index}`"
                >{{ item }}
                </th>
              </tr>
              </thead>
            </table>
            <div class="border-header"/>
            <table border="0" cellspacing="0" cellpadding="0" class="school-table-table">
              <tbody>
              <template v-for="(item, index) in tableRows">
                <tr :key="item['label'] + '_' + index" v-if="item['label']" class="body-header">
                  <th colspan="100%">
                    {{ $t(item["label"].trim()) }}
                    <v-tooltip
                      top
                      content-class="school-tooltip"
                      close-delay="1000"
                      color="#3a5a86"
                      v-if="toolTipByName($t(item['label']))">
                      <template v-slot:activator="{ on }">
                        <v-icon class="tooltip-icon" v-on="on" @click="adjustArrowPosition">help</v-icon>
                      </template>
                      <div v-html="toolTipByName($t(item['label']))"></div>
                    </v-tooltip>
                  </th>
                </tr>

                <tr :key="index">
                  <td>
                    {{ $t(item["IndexDesc"].trim()) }}
                    <v-tooltip
                      top
                      content-class="school-tooltip"
                      close-delay="1000"
                      color="#3a5a86"
                      v-if="isSecondary && toolTipByName($t(item['IndexDesc'].trim()))">
                      <template v-slot:activator="{ on }">
                        <v-icon class="tooltip-icon" v-on="on" @click="adjustArrowPosition">help</v-icon>
                      </template>
                      <div v-html="toolTipByName($t(item['IndexDesc'].trim()))"></div>
                    </v-tooltip>
                  </td>
                  <td
                    v-for="(year, index_year) in tableCurrentPages"
                    :key="index_year"
                  >{{ item[year] }}
                  </td>
                </tr>
              </template>
              </tbody>
            </table>
            <div class="border-dotted"/>
            <table class="school-table-table">
              <tbody
                class="single-item-body"
                v-for="(item, index ) in singleSchool.reportCardDataBottom"
                :key="index"
              >
              <tr>
                <td>
                  {{ $t(item["IndexDesc"].trim()) }}
                  <v-tooltip
                    top
                    content-class="school-tooltip"
                    close-delay="1000"
                    color="#3a5a86"
                    v-if="toolTipByName($t(item['IndexDesc'].trim()))">
                    <template v-slot:activator="{ on }">
                      <v-icon class="tooltip-icon" v-on="on" @click="adjustArrowPosition">help</v-icon>
                    </template>
                    <div v-html="toolTipByName($t(item['IndexDesc'].trim()))"></div>
                  </v-tooltip>
                </td>
                <td
                  v-for="(year, index_year) in tableCurrentPages"
                  :key="index_year"
                >{{ item[year] }}
                </td>
              </tr>
              </tbody>
            </table>
            <v-flex
              xs12
              class="school-table-note"
              v-if="singleSchool && singleSchool.province === 'on'"
            >Note: Most provinces paused their testing programs for two years as part of their policy response to Covid-19 so we will not be able to fill in the historical results for 2020 or 2021.
            </v-flex>
            <v-flex
              xs12
              class="school-table-note"
              v-if="singleSchool && singleSchool.province === 'bc' && !isSecondary"
            ><p>Note: In the 2021/22 school year, the BC government replaced the Reading and Writing FSAs with a Literacy FSA as part of changes to align with the new curriculum. As a result, the two FSAs ‘Reading’ and ‘Writing’ are replaced in 2022 by a single FSA, ‘Literacy’. The results for the new FSA, ‘Literacy’ are not comparable to earlier results for ‘Reading’ and ‘Writing’.</p>
            </v-flex>
            <v-flex
              xs12
              class="school-table-note"
              v-if="singleSchool && singleSchool.province === 'ab'"
            ><p>Note: Most provinces paused their testing programs for two years as part of their policy response to Covid-19 so we will not be able to fill in the historical results for 2020 or 2021. Courses taken per student calculation for 2023 is revised.</p>
            </v-flex>
            <v-flex
              xs12
              class="school-table-note"
              v-if="singleSchool && singleSchool.province === 'qc' && languageIs('en')"
            ><p>Note: Most provinces paused their testing programs for two years as part of their policy response to Covid-19 so we will not be able to fill in the historical results for 2020 or 2021.</p>
            </v-flex>
            <v-flex
              xs12
              class="school-table-note"
              v-if="singleSchool && singleSchool.province === 'qc' && languageIs('fr')"
            ><p>Note: La plupart des provinces ont interrompu leurs programmes d’examens pendant deux ans dans le cadre de leur réponse à la COVID-19. Nous ne serons donc pas en mesure de présenter les résultats pour 2020 ni 2021.</p>
            </v-flex>
          </v-flex>
        </v-flex>
      </v-flex>
    </v-flex>
    <SchoolCompare
      :schools="fetchedSchools"
      v-if="showCompare"/>

    <!-- Mobile -->
    <div v-show="isMobile">
      <v-layout row wrap class="school-page-compare-button" id="school-page-compare-button" v-show="compareSchoolTotal > 0">
        <v-flex xs12 class="content">
          <a href="#" @click.stop.prevent="initShowCompare">
            <v-flex class="compare-text">
              {{ $t('Compare schools') }}
            </v-flex>
            <v-flex>
              ({{ compareSchoolTotal }}/6)
            </v-flex>
          </a>
        </v-flex>
      </v-layout>
    </div>
    <!-- Desktop -->
    <div v-show="!isMobile">
      <v-layout row wrap class="school-map-compare-bar" id="school-map-compare-bar" v-show="compareSchoolTotal > 0">
        <a href="#" @click.stop.prevent="closeCompareBar" class="close">
            {{ $t('Close') }} <i class="material-icons">close</i>
        </a>
        <v-flex xs3 class="compare-text">
          {{ $t('Compare schools') }}
          <div>({{ compareSchoolTotal }}/6)</div>
        </v-flex>
        <v-flex xs6>
          <div class="items-to-compare">
            <div class="list">
              <div class="list-item" v-for="(school, index) in schoolsToCompare" :key="index" >
                <i @click.stop.prevent="removeSchoolFromCompare(school)" class="material-icons">close</i>
                {{ school.name }}
              </div>
            </div>
          </div>
        </v-flex>
        <v-flex xs2 class="compare-now">
          <a href="#" @click.stop.prevent="initShowCompare" class="compare-now">  {{ $t('Compare now') }} </a>
        </v-flex>
      </v-layout>
    </div>
    <SchoolNotification
      :province="singleSchool.province"
      :showNotification="showNotification"
      :schoolType="singleSchool.level"
      :schoolName="singleSchool.name"
      :schoolId="singleSchool.id"
      @sendCloseDialog="showNotification = false"
    />

    <SchoolSendMailModal ref="emailModal"/>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex';
  import SchoolPageMap from "@/components/SchoolMap/SchoolPageMap";
  import SchoolChart from "@/components/SchoolMap/SchoolChart";
  import RepositoryFactory from "@/services/RepositoryFactory";

  const SchoolService = RepositoryFactory.get("schools");
  const StorageService = RepositoryFactory.get('storage');
  const SystemRepository = RepositoryFactory.get('system');
  import SchoolNotification from '@/components/SchoolMap/SchoolNotification';
  import SchoolSendMailModal from '@/components/SchoolMap/SchoolSendMailModal';
  import SchoolCompare from '@/components/SchoolMap/SchoolCompare';

  export default {
    name: "SchoolPage",
    components: {
      SchoolChart,
      SchoolPageMap,
      SchoolNotification,
      SchoolSendMailModal,
      SchoolCompare
    },
    data() {
      return {
        showNotification: false,
        province: false,
        school_id: 0,
        schoolName: false,
        panel: [],
        isMobile: false,
        singleSchoolMap: null,
        table_active: 0,
        showSchoolChart: true,
        showSchoolTable: false,
        chartType: "single",
        singleSchool: {},
        singleSchoolLoaded: false,
        totalSchools: 0,
        reloadSchoolMap: false,
        tableNumberPages: 5,
        tablePageStart: 0,
        tablePages: null,
        iconUrl: null,
        level: null,
        fetchedSchools: [],
        currentPage: window.location.href,
      };
    },
    computed: {
      ...mapGetters([
        'getProvinceCode',
      ]),
      tableCurrentPages() {
        return (this.tablePages)
            ? this.tablePages.slice(
                this.tablePageStart,
                this.tablePageStart + this.tableNumberPages
            )
            : null;
      },
      tableRows() {
        let rows = this.singleSchool.reportCardData;

        if (rows) {
          let prevLabel = '';

          rows.forEach(item => {
            let itemLabel = item['label'];
            if (itemLabel && itemLabel === prevLabel) {
              item['label'] = null;
            }
            prevLabel = itemLabel;
          });
        }

        return rows;
      },
      isSecondary() {
        return this.level === 'secondary';
      },
      isOntarioProvince() {
        return this.$store.state.currentMapProvince === 'Ontario';
      },
      getEnrolmentName() {
        return this.isSecondary
            ?
            (this.$store.state.currentMapProvince !== 'Ontario'
                    ? 'Gr 12 Enrolment'
                    : ''
            )
            : (this.$store.state.currentMapProvince === 'British Columbia'
                    ? 'Gr 4 Enrolment'
                    : 'Gr 6 Enrolment'
            );
      },
      enrolmentValue() {
        return this.isSecondary
            ?
            (this.$store.state.currentMapProvince !== 'Ontario'
                    ? 'GradeTwelveEnroll'
                    : ''
            )
            : (this.$store.state.currentMapProvince === 'British Columbia'
                    ? 'GradeFourEnroll'
                    : 'GradeSixEnroll'
            );
      },
      getImmersionName() {
        switch (this.$store.state.currentMapProvince) {
          case 'Alberta':
            return 'Alt. French %';
          case 'Ontario':
            return '';
          default:
            return 'French Immersion %';
        }
      },
      compareSchoolTotal() {
        let compare_button = document.getElementsByClassName("school-page-compare-button");
        if (compare_button[0] != undefined) {
          compare_button[0].style.background="white";
          // eslint-disable-next-line
          setTimeout(() => {
            compare_button[0].style.background="#008485";
          }, 200);
        }
        return this.$store.state.compareSchool.length;
      },
      showCompare: {
        get: function() {
          return this.$store.state.dialogCompareSchool;
        },
        set: function(value) {
          this.$store.commit("SET_DIALOG_COMPARE_SCHOOL", value);
        }
      },
      schoolMapPageReady() {
        return this.singleSchoolLoaded && this.singleSchool && this.singleSchool.coords;
      },
      schoolsToCompare() {
        return this.$store.state.compareSchool;
      }
    },
    mounted() {
      const self = this;

      window.addEventListener("resize", self.checkIsMobile);
      self.checkIsMobile();
      self.getSchoolById(self.$route.params.id, self.$route.params.level, self.$route.params.province)
          .then(result => {
            self.singleSchool = JSON.parse(JSON.stringify(result));
            console.log(self.singleSchool);
            SchoolService.formatSchool(self.singleSchool);
            self.singleSchoolLoaded = true;
            self.$store.dispatch("setCurrentMapProvince", self.getProvinceCode(self.singleSchool.province));
            if (self.$store.state.initialSearchSchoolListFilteredCount > 0) {
              self.totalSchools = self.$store.state.initialSearchSchoolListFilteredCount;
            }
            else {
              let level = self.singleSchool.level;
              let currentProvince = self.singleSchool.province;
              let schoolData = StorageService.getItem('schoolData');

              if (schoolData !== null) {
                schoolData = JSON.parse(schoolData);

                let schoolsByLevel = schoolData.filter(item => {
                  return item.location !== null && item.level === level &&
                    item.province === currentProvince
                });

                self.totalSchools = schoolsByLevel.length;
              }
            }
          });

      setTimeout(() => {
        const toolTips = document.querySelectorAll('.school-tooltip');
        Array.from(toolTips).forEach((tooltip) => {
          let node = document.createElement("div");
          node.className = "school-tooltip-arrow";
          tooltip.appendChild(node);
        });
      }, 1000);
      window.addEventListener('resize', this.checkIsMobile);
      this.checkIsMobile();
    },
    methods: {
      languageIs(language) {
        return localStorage.getItem('language') === language;
      },
      print() {
        window.print();
      },
      openEmailModal() {
        this.$refs.emailModal.openModal();
      },
      toolTipByName(name) {
        let tooltip;
        if (name) {
          tooltip = SystemRepository.getTooltipByName(name, this.singleSchool.province, this.singleSchool.level, localStorage.getItem('language'));
        }
        return tooltip || null;
      },
      adjustArrowPosition: function (event) {
        let leftPosition = event.target.offsetLeft + 8;
        setTimeout(() => {
          const arrows = document.querySelectorAll('.school-tooltip-arrow');
          Array.from(arrows).forEach((arrow) => {
            arrow.style.left = leftPosition + 'px';
          });
        }, 50);
      },
      async getSchoolById(id, level, province) {
        let vm = this;
        /*console.info({
          "element-model": 'Page load',
          "action: ": "Loading School page data",
          "request": `Get School By ID: ${id}`,
          time: Math.floor(Date.now() / 1000)
        },"EVENT");*/
        const school = await SchoolService.getById(id, level, province);

        let indicator_years = [];
        if (school['schoolInfoData']) {
          Object.keys(school['schoolInfoData']).forEach(function(key) {
            const ignore_keys = [
              'AreaName',
              'IND_or_PUB',
              'ESL',
              'ELL',
              'Special needs',
              'SpNeeds',
              'French Imm',
              'FrImm',
              'Rank This Yr',
              'GradeSixEnroll',
              'OSSLTCOUNT',
              'GradeTwelveEnroll',
              'GradeFourEnroll',
              'NUMBER_STUDENTS',
              'EN_RETARD',
              'EHDAA',
            ];
            // Validation apply to values 'n/d' or 'n/a' exclude AreaName position.
            if (isNaN(Number(school['schoolInfoData'][key])) && !ignore_keys.includes(key)) {
              school['schoolInfoData'][key] = 0;
            }
            if (key && !isNaN(Number(school['schoolInfoData'][key]))
                  && !isNaN(Number(key))
                  && school['schoolInfoData'][key] !== null) {
                indicator_years.push(key);
              }
          });
        }
        indicator_years.sort(function(a, b) {return b-a});
        this.tablePages = indicator_years;
        let school_type = school["schoolInfoData"]["IND_or_PUB"];
        let esl = school["schoolInfoData"]["ESL"] ? school["schoolInfoData"]["ESL"] : school["schoolInfoData"]["ELL"] ? school["schoolInfoData"]["ELL"] : 0;
        let special_needs = school["schoolInfoData"]["Special needs"]
            ? school["schoolInfoData"]["Special needs"]
            : (school["schoolInfoData"]["SpNeeds"] !== undefined
                ? school["schoolInfoData"]["SpNeeds"]
                : 0);
        let french_immersion = school["schoolInfoData"]["French Imm"] !== undefined
            ? school["schoolInfoData"]["French Imm"]
            : school["schoolInfoData"]["FrImm"];

        school.chartData = {};

        let reportCardDatas = [];
        let reportCardDataBottom = [];

        if (school['reportCardData']) {
          reportCardDatas = school['reportCardData'].slice(
            0,
            school['reportCardData'].length - 3
          );
          reportCardDataBottom = school['reportCardData'].slice(-3);
        }

        let label;
        reportCardDatas.forEach(reportCardData => {
          label = reportCardData["label"] !== undefined ? reportCardData["label"] : label !== undefined ? label : '';

          let desc = reportCardData["IndexDesc"].trim();
          desc = desc !== undefined ? desc.trim() : "";
          let indexDesc = label ? label + ": " + desc : desc;
          indexDesc = indexDesc.trim();
          school.chartData[indexDesc] = {};
          indicator_years.forEach(year => {
            if (year in reportCardData) {
              school.chartData[indexDesc][year] = reportCardData[year];
            }
          });
        });

        reportCardDataBottom.forEach(reportCardData => {
          let indexDesc = reportCardData["IndexDesc"].trim();
          school.chartData[indexDesc] = {};
          indicator_years.forEach(year => {
            if (year in reportCardData) {
              school.chartData[indexDesc][year] = reportCardData[year];
            }
          });
        });
        this.level = school.schoolType;
        this.iconUrl = vm.dynamicIcon(school.score);
        let gr_enrolment = school["schoolInfoData"][this.enrolmentValue];
        let ossl_count = school.schoolInfoData["OSSLTCOUNT"] ? school.schoolInfoData["OSSLTCOUNT"] : null;

        let schoolData =  {
          id: school.sid,
          name: school.title,
          phone: school.contactData["Phone"],
          district: school.schoolInfoData["AreaName"],
          coords: school.coords,
          address: school.fullAddress,
          type: "Public",
          score: school.score,
          reportCardData: reportCardDatas,
          reportCardDataBottom: reportCardDataBottom,
          indicator_years: indicator_years,
          school_type: school_type,
          ranking: school["schoolInfoData"]["Rank This Yr"],
          trend: school.trend,
          esl: esl,
          special_needs: special_needs,
          gr_enrolment: gr_enrolment,
          french_immersion: french_immersion,
          website: school.website,
          province: school.province,
          chartData: school.chartData,
          level: school.schoolType,
          ossl_count: ossl_count
        };

        if (schoolData.ranking === 0 && schoolData.id === '2396281') {
          schoolData.ranking = 'n/a';
        }
        if (school.province == 'qc') {
          schoolData.studentsNumber = school['schoolInfoData']['NUMBER_STUDENTS'];
          schoolData.academicDelay = school['schoolInfoData']['EN_RETARD'];
          schoolData.specialNeeds = school['schoolInfoData']['EHDAA'];
        }

        return schoolData;
      },
      reloadSchoolMapAction() {
        this.reloadSchoolMap = !this.reloadSchoolMap;
        if (this.schoolMapPageReady && this.reloadSchoolMap) {
          this.$refs.schoolPageMap.singleSchoolMap._onResize();
        }
      },
      checkIsMobile() {
        this.isMobile = parseInt(document.documentElement.clientWidth) < 960;
        if (this.isMobile) {
          this.tableNumberPages = 3;
        }
        else {
          this.panel = 0;
          this.tableNumberPages = 5;
        }
      },
      dynamicIcon(rating) {
        if (rating === 'n/a') {
          return "marker_grey.svg";
        }
        if (rating <= 4) {
          return "marker_red.svg";
        }
        else if (rating <= 5.9) {
          return "marker_orange.svg";
        }
        else if (rating <= 7.5) {
          return "marker_yellow.svg";
        }
        else {
          return "marker_green.svg";
        }
      },
      addToCompare(school) {
        let schools = this.$store.state.compareSchool;
        if (
            (schools.filter(function (e) {
                  return e.id === school.id;
                }).length === 0 ||
                schools.length === 0
            ) &&
            schools.length < 6
        ) {
          schools.push(school);
          this.$store.commit('SET_COMPARE_SCHOOL', schools);
        }
      },
      nextPageStart() {
        if (
            this.tablePages.length - this.tableNumberPages >
            this.tablePageStart
        ) {
          this.tablePageStart = this.tablePageStart + 1;
        }
      },
      previousPageStart() {
        if (this.tablePageStart > 0) {
          this.tablePageStart = this.tablePageStart - 1;
        }
      },
      async initShowCompare() {
        document.getElementsByClassName('application--wrap')[0].classList.add('loading');
        await this.fetchSchoolsToCompare();
        setTimeout(() => {
          this.showCompare = true;
          document.getElementsByClassName('application--wrap')[0].classList.remove('loading');
        }, 1);
      },
      async fetchSchoolsToCompare() {
        let schools = await this.$store.state.compareSchool;
        await this.fetchSchools(schools);
      },
      async fetchSchools(schools) {
        let vm = this;
        await this.asyncForEach(schools, async (school) => {
          /*console.info({
            "element-model": 'school-page-compare-button',
            "action: ": "Click on PAGE compare button",
            "request": `Get School By ID: ${school.id}`,
            time: Math.floor(Date.now() / 1000)
          },"EVENT");*/
          vm.fetchedSchools[school.id] = await SchoolService.getById(school.id, school.level, school.province);
        });
      },
      async asyncForEach(array, callback) {
        for (let index = 0; index < array.length; index++) {
          await callback(array[index], index, array);
        }
      },
      removeSchoolFromCompare(school) {
        let schoolsInStore = this.$store.state.compareSchool;
        let results = schoolsInStore.filter(item => item.id != school.id);
        this.$store.commit("SET_COMPARE_SCHOOL", results);
      },
      closeCompareBar() {
        this.$store.commit("SET_COMPARE_SCHOOL", []);
      }
    }
  };
</script>
